// src/components/QueryInput/config.js
export const API_URL = "https://on-request-example-5ai7wqmgta-uc.a.run.app";
